import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=c62cb9e8"
import script from "../../controllers/teacher/teacher-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-create.js?vue&type=script&lang=js&external"
import style0 from "./TeacherCreate.vue?vue&type=style&index=0&id=c62cb9e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports